import { PackageModulesFormBaseDataProvider } from './PackageModulesFormBaseDataProvider';
import { OperationModeData } from '../../../types/operation-mode-data';
import { MonthlyProductType } from '../../../../license/types/MonthlyProductType';
import { translateFn } from '../../../../utils/translator.helper';

export class PackageModulesFormGzDataProvider extends PackageModulesFormBaseDataProvider {
  public getOperationModes(): OperationModeData[] {
    return [
      {
        value: MonthlyProductType.EndpointSecurity,
        title: translateFn('Detection and prevention'),
      },
      {
        value: MonthlyProductType.BitdefenderEdr,
        title: translateFn('EDR (Report only)'),
      },
    ];
  }
}
